import { ProgramHeaderItem } from "../types";
import { ConsoleRouteMap } from "apps/console/routes/routes";
import ProgramHeaderBehaviour from "./programHeaderBehaviour";
import TradeProgramStatus from "shared/enums/TradeProgramStatus";
import BuyersProgramStatus from "shared/enums/BuyersProgramStatus";
import MeetupProgramStatus from "shared/enums/MeetupProgramStatus";
import TabletalkProgramStatus from "shared/enums/TabletalkProgramStatus";
import AssociatedProgramStatus from "shared/enums/AssociateProgramStatus";
import InPersonMeetupProgramStatus from "shared/enums/InPersonMeetupProgramStatus";

export class ConsoleBehaviour extends ProgramHeaderBehaviour {
  getInPersonMeetupProgramStatusHeaderList(): Array<ProgramHeaderItem<InPersonMeetupProgramStatus>> {
    return [
      {
        displayOrder: 1,
        stagesIncluded: [InPersonMeetupProgramStatus.CONFIGURATION, InPersonMeetupProgramStatus.ENROLLMENT],
        labelKey: "program.header.enrollment",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.ENROLLMENT.path
      },
      {
        displayOrder: 2,
        stagesIncluded: [InPersonMeetupProgramStatus.PROFILE, InPersonMeetupProgramStatus.PROFILE_ADMIN],
        labelKey: "program.header.profile",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.PROFILE.path
      },
      {
        displayOrder: 3,
        stagesIncluded: [
          InPersonMeetupProgramStatus.SELECTION_ROUND_1,
          InPersonMeetupProgramStatus.SELECTION_ROUND_1_ADMIN
        ],
        labelKey: "program.header.selection.1",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.SELECTION_ROUND_1.path
      },
      {
        displayOrder: 4,
        stagesIncluded: [
          InPersonMeetupProgramStatus.SELECTION_ROUND_2,
          InPersonMeetupProgramStatus.SELECTION_ROUND_2_ADMIN
        ],
        labelKey: "program.header.selection.2",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.SELECTION_ROUND_2.path
      },
      {
        displayOrder: 5,
        stagesIncluded: [
          InPersonMeetupProgramStatus.SELECTION_ROUND_3,
          InPersonMeetupProgramStatus.SELECTION_ROUND_3_ADMIN
        ],
        labelKey: "program.header.selection.3",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.SELECTION_ROUND_3.path
      },
      {
        displayOrder: 6,
        stagesIncluded: [
          InPersonMeetupProgramStatus.MEETING_MATCHING,
          InPersonMeetupProgramStatus.ACCEPT_MEETINGS,
          InPersonMeetupProgramStatus.ADDITIONAL_MEETING_MATCHING,
          InPersonMeetupProgramStatus.ACCEPT_ADDITIONAL_MEETINGS,
          InPersonMeetupProgramStatus.INVITES_SENT,
          InPersonMeetupProgramStatus.IN_PROGRESS,
          InPersonMeetupProgramStatus.RECONCILIATION
        ],
        labelKey: "program.header.meeting",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.MEETING.path
      },
      {
        displayOrder: 7,
        stagesIncluded: [InPersonMeetupProgramStatus.FEEDBACK],
        labelKey: "program.header.feedback",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.FEEDBACK.path
      },
      {
        displayOrder: 8,
        stagesIncluded: [InPersonMeetupProgramStatus.REIMBURSEMENT],
        labelKey: "program.header.reimbursement",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.REIMBURSEMENT.path
      }
    ];
  }

  getBuyersProgramStatusHeaderList(): Array<ProgramHeaderItem<BuyersProgramStatus>> {
    return [
      {
        displayOrder: 1,
        stagesIncluded: [BuyersProgramStatus.CONFIGURATION, BuyersProgramStatus.ENROLLMENT],
        labelKey: "program.header.enrollment",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.ENROLLMENT.path
      },
      {
        displayOrder: 2,
        stagesIncluded: [BuyersProgramStatus.PROFILE, BuyersProgramStatus.PROFILE_ADMIN],
        labelKey: "program.header.profile",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.PROFILE.path
      },
      {
        displayOrder: 3,
        stagesIncluded: [BuyersProgramStatus.SELECTION_ROUND_1, BuyersProgramStatus.SELECTION_ROUND_1_ADMIN],
        labelKey: "program.header.selection.1",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.SELECTION_ROUND_1.path
      },
      {
        displayOrder: 4,
        stagesIncluded: [BuyersProgramStatus.SELECTION_ROUND_2, BuyersProgramStatus.SELECTION_ROUND_2_ADMIN],
        labelKey: "program.header.selection.2",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.SELECTION_ROUND_2.path
      },
      {
        displayOrder: 5,
        stagesIncluded: [BuyersProgramStatus.SELECTION_ROUND_3, BuyersProgramStatus.SELECTION_ROUND_3_ADMIN],
        labelKey: "program.header.selection.3",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.SELECTION_ROUND_3.path
      },
      {
        displayOrder: 6,
        stagesIncluded: [
          BuyersProgramStatus.MEETING_MATCHING,
          BuyersProgramStatus.ACCEPT_MEETINGS,
          BuyersProgramStatus.ADDITIONAL_MEETING_MATCHING,
          BuyersProgramStatus.ACCEPT_ADDITIONAL_MEETINGS,
          BuyersProgramStatus.INVITES_SENT,
          BuyersProgramStatus.IN_PROGRESS,
          BuyersProgramStatus.RECONCILIATION
        ],
        labelKey: "program.header.meeting",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.MEETING.path
      },
      {
        displayOrder: 7,
        stagesIncluded: [BuyersProgramStatus.FEEDBACK],
        labelKey: "program.header.feedback",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.FEEDBACK.path
      },
      {
        displayOrder: 8,
        stagesIncluded: [BuyersProgramStatus.REIMBURSEMENT],
        labelKey: "program.header.reimbursement",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.REIMBURSEMENT.path
      }
    ];
  }

  getMeetupProgramStatusHeaderList(): Array<ProgramHeaderItem<MeetupProgramStatus>> {
    return [
      {
        displayOrder: 1,
        stagesIncluded: [MeetupProgramStatus.CONFIGURATION, MeetupProgramStatus.ENROLLMENT],
        labelKey: "program.header.enrollment",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.ENROLLMENT.path
      },
      {
        displayOrder: 2,
        stagesIncluded: [MeetupProgramStatus.PROFILE, MeetupProgramStatus.PROFILE_ADMIN],
        labelKey: "program.header.profile",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.PROFILE.path
      },
      {
        displayOrder: 3,
        stagesIncluded: [MeetupProgramStatus.SELECTION_ROUND_1, MeetupProgramStatus.SELECTION_ROUND_1_ADMIN],
        labelKey: "program.header.selection.1",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.SELECTION_ROUND_1.path
      },
      {
        displayOrder: 4,
        stagesIncluded: [MeetupProgramStatus.SELECTION_ROUND_2, MeetupProgramStatus.SELECTION_ROUND_2_ADMIN],
        labelKey: "program.header.selection.2.optin",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.SELECTION_ROUND_2.path
      },
      {
        displayOrder: 5,
        stagesIncluded: [
          MeetupProgramStatus.MEETING_MATCHING,
          MeetupProgramStatus.ACCEPT_MEETINGS,
          MeetupProgramStatus.ADDITIONAL_MEETING_MATCHING,
          MeetupProgramStatus.ACCEPT_ADDITIONAL_MEETINGS,
          MeetupProgramStatus.INVITES_SENT,
          MeetupProgramStatus.IN_PROGRESS,
          MeetupProgramStatus.RECONCILIATION
        ],
        labelKey: "program.header.meeting",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.MEETING.path
      },
      {
        displayOrder: 6,
        stagesIncluded: [MeetupProgramStatus.FEEDBACK],
        labelKey: "program.header.feedback",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.FEEDBACK.path
      },
      {
        displayOrder: 7,
        stagesIncluded: [MeetupProgramStatus.REIMBURSEMENT],
        labelKey: "program.header.reimbursement",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.REIMBURSEMENT.path
      }
    ];
  }

  getTradeProgramStatusHeaderList(): Array<ProgramHeaderItem<TradeProgramStatus>> {
    return [
      {
        displayOrder: 1,
        stagesIncluded: [TradeProgramStatus.CONFIGURATION, TradeProgramStatus.ENROLLMENT],
        labelKey: "program.header.enrollment",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.ENROLLMENT.path
      },
      {
        displayOrder: 2,
        stagesIncluded: [TradeProgramStatus.PROFILE, TradeProgramStatus.PROFILE_ADMIN],
        labelKey: "program.header.profile",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.PROFILE.path
      },
      {
        displayOrder: 3,
        stagesIncluded: [TradeProgramStatus.SELECTION_ROUND_1, TradeProgramStatus.SELECTION_ROUND_1_ADMIN],
        labelKey: "program.header.selection.1",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.SELECTION_ROUND_1.path
      },
      {
        displayOrder: 4,
        stagesIncluded: [TradeProgramStatus.SELECTION_ROUND_2, TradeProgramStatus.SELECTION_ROUND_2_ADMIN],
        labelKey: "program.header.selection.2",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.SELECTION_ROUND_2.path
      },
      {
        displayOrder: 5,
        stagesIncluded: [TradeProgramStatus.SELECTION_ROUND_3, TradeProgramStatus.SELECTION_ROUND_3_ADMIN],
        labelKey: "program.header.selection.3",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.SELECTION_ROUND_3.path
      },
      {
        displayOrder: 6,
        stagesIncluded: [
          TradeProgramStatus.MEETING_MATCHING,
          TradeProgramStatus.ACCEPT_MEETINGS,
          TradeProgramStatus.INVITES_SENT,
          TradeProgramStatus.IN_PROGRESS,
          TradeProgramStatus.RECONCILIATION
        ],
        labelKey: "program.header.meeting",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.MEETING.path
      },
      {
        displayOrder: 7,
        stagesIncluded: [TradeProgramStatus.FEEDBACK],
        labelKey: "program.header.feedback",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.FEEDBACK.path
      },
      {
        displayOrder: 8,
        stagesIncluded: [TradeProgramStatus.REIMBURSEMENT],
        labelKey: "program.header.reimbursement",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.REIMBURSEMENT.path
      }
    ];
  }

  getTabletalkProgramStatusHeaderList(): Array<ProgramHeaderItem<TabletalkProgramStatus>> {
    return [
      {
        displayOrder: 1,
        stagesIncluded: [TabletalkProgramStatus.CONFIGURATION, TabletalkProgramStatus.PARTICIPANT_REVIEW],
        labelKey: "program.header.enrollment",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.TABLETALK_ENROLLMENT.path
      },
      {
        displayOrder: 2,
        stagesIncluded: [
          TabletalkProgramStatus.PARTICIPANT_APPLICATION,
          TabletalkProgramStatus.PARTICIPANT_APPLICATION_REVIEW
        ],
        labelKey: "program.header.profile",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.TABLETALK_PROFILE.path
      },
      {
        displayOrder: 3,
        stagesIncluded: [TabletalkProgramStatus.INITIAL_SYSTEM_MATCHING],
        labelKey: "program.header.meeting",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.TABLETALK_MEETING.path
      },
      {
        displayOrder: 4,
        stagesIncluded: [
          TabletalkProgramStatus.ACCEPT_MEETINGS,
          TabletalkProgramStatus.FINAL_SYSTEM_MATCHING,
          TabletalkProgramStatus.FINAL_INVITES,
          TabletalkProgramStatus.IN_PROGRESS,
          TabletalkProgramStatus.RECONCILIATION
        ],
        labelKey: "program.header.accept.reject",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.TABLETALK_ACCEPT_MEETINGS.path
      },
      {
        displayOrder: 5,
        stagesIncluded: [TabletalkProgramStatus.FEEDBACK],
        labelKey: "program.header.feedback",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.TABLETALK_FEEDBACK.path
      }
    ];
  }

  getAssociatedProgramStatusHeaderList(
    _: AssociatedProgramStatus,
    _1?: string
  ): Array<ProgramHeaderItem<AssociatedProgramStatus>> {
    return [
      {
        displayOrder: 1,
        // TODO: TW: remove AssociatedProgramStatus.SELECTION from here and enable request tab once implemented
        // stagesIncluded: [AssociatedProgramStatus.CONFIGURATION, AssociatedProgramStatus.ACTIVITY_PROFILE],
        stagesIncluded: [
          AssociatedProgramStatus.CONFIGURATION,
          AssociatedProgramStatus.ACTIVITY_PROFILE,
          AssociatedProgramStatus.SELECTION
        ],
        labelKey: "program.header.activity.profile",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.ASSOCIATED_PROGRAM.PROFILE.ACTIVITY_CONFIG.path
      },
      /* {
        displayOrder: 2,
        stagesIncluded: [AssociatedProgramStatus.SELECTION],
        labelKey: "program.header.request",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.ASSOCIATED_PROGRAM.REQUEST.path
      }, */
      {
        displayOrder: 3,
        stagesIncluded: [AssociatedProgramStatus.SHORTLIST],
        labelKey: "program.header.shortlist",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.ASSOCIATED_PROGRAM.SHORTLIST.path
      },
      {
        displayOrder: 4,
        stagesIncluded: [
          AssociatedProgramStatus.ACTIVITY_MATCHING,
          AssociatedProgramStatus.ACCEPT_ACTIVITY_SCHEDULE,
          AssociatedProgramStatus.INVITES_SENT,
          AssociatedProgramStatus.IN_PROGRESS,
          AssociatedProgramStatus.RECONCILIATION,
          AssociatedProgramStatus.FEEDBACK,
          AssociatedProgramStatus.COMPLETED
        ],
        labelKey: "program.header.activities",
        path: ConsoleRouteMap.PROGRAM.WORKFLOW.ASSOCIATED_PROGRAM.ATTENDANCE.path
      }
    ];
  }
}
